export const MOCK_SERVICES = [
  {
    "id": "8895ff4d-7953-403b-b987-5e8e5fa97819",
    "category": "main",
    "title": { "da": "Ejendomsservice" },
    "url_slug": "ejendomsservice",
    "slug": { "da": "ejendomsservice" },
    "image": ["https://assets.auxodev.dk/assets/8a41795c-dcbb-4ba1-a6ae-e2582bf01d41/image00001.jpeg"],
    "description": {
      "da": "<p>Vi tilbyder professionel ejendomsservice med fokus på vedligeholdelse af grønne områder for både private, virksomheder, boligforeninger og kommuner.</p><p>Vores service inkluderer alt fra pleje af udearealer til løbende vedligeholdelse, der sikrer, at jeres områder altid fremstår præsentable og velplejede. Vi lægger stor vægt på stabilitet, kvalitet og en personlig dialog, så vi altid leverer en løsning, der matcher jeres behov.</p><h2>Hvad vi tilbyder:</h2><ul><li>Vedligeholdelse af grønne områder</li><li>Pleje af udearealer og fællesområder</li><li>Serviceaftaler tilpasset boligforeninger og virksomheder</li><li>Hurtig og effektiv hjælp til kommunale arealer</li></ul>"
    }
  },
  {
    "id": "cb16864e-9a16-459b-af5b-4e6b6512bcf1",
    "category": "other",
    "title": { "da": "Græsslåning" },
    "url_slug": "graesslaaning",
    "slug": { "da": "graesslaaning" },
    "image": ["https://assets.auxodev.dk/assets/8a41795c-dcbb-4ba1-a6ae-e2582bf01d41/image00016.jpeg"],
    "description": {
      "da": "<p>En velholdt græsplæne er fundamentet for et flot udemiljø. Vi tilbyder regelmæssig græsslåning for både private haveejere og større erhvervsarealer.</p><p>Uanset om det er en lille parcelhushave eller store fællesarealer, sørger vi for, at græsset bliver slået præcist og til tiden. Vi benytter professionelt udstyr, der sikrer et flot resultat hver gang.</p>"
    }
  },
  {
    "id": "a4ed2219-3380-4537-8fdd-cb926b792e07",
    "category": "other",
    "title": { "da": "Flishugning" },
    "url_slug": "flishugning",
    "slug": { "da": "flishugning" },
    "image": ["https://assets.auxodev.dk/assets/8a41795c-dcbb-4ba1-a6ae-e2582bf01d41/image00005.jpeg"],
    "description": {
      "da": "<p>Har du grene eller mindre træmateriale, der skal afskaffes? Vi tilbyder effektiv flishugning, der forvandler dit haveaffald til praktisk flis.</p><p>Vores flishugger kan håndtere mindre opgaver hurtigt og nemt, og vi sørger naturligvis for oprydning efter arbejdet, så dit område efterlades pænt og ryddeligt. Det er en ideel løsning efter beskæring eller fældning af mindre træer.</p>"
    }
  },
  {
    "id": "5dd7d11b-2d88-4346-a837-15d2fad0be80",
    "category": "other",
    "title": { "da": "Havearbejde" },
    "url_slug": "havearbejde",
    "slug": { "da": "havearbejde" },
    "image": ["https://assets.auxodev.dk/assets/8a41795c-dcbb-4ba1-a6ae-e2582bf01d41/image00012.jpeg"],
    "description": {
      "da": "<p>Har haven brug for en kærlig hånd? Vi tilbyder hjælp til mindre haveopgaver ved efterspørgsel.</p><p>Dette inkluderer opgaver som klipning af hække, lugning af bede, generel oprydning og klargøring til sæsonen. Vi ser havearbejde som en ekstra service, vi tilbyder vores faste kunder eller ved specifikke forespørgsler, hvor der er brug for en ekstra hånd til det grønne.</p>"
    }
  }
];

export const MOCK_GALLERY = [
  {
    "id": "16f588d8-e09f-4cfd-afac-7fcd5edc42ce",
    "title": { "da": "Velplejet haveanlæg og hovedejendom" },
    "image": ["https://assets.auxodev.dk/assets/8a41795c-dcbb-4ba1-a6ae-e2582bf01d41/image00020.jpeg"]
  },
  {
    "id": "285e1894-b6df-42eb-9f94-be991152459c",
    "title": { "da": "Havearbejde og nyanlagt bed" },
    "image": ["https://assets.auxodev.dk/assets/8a41795c-dcbb-4ba1-a6ae-e2582bf01d41/image00021.jpeg"]
  },
  {
    "id": "b7269b15-7610-43f7-8627-dd71468b23d3",
    "title": { "da": "Store grønne arealer og beplantning" },
    "image": ["https://assets.auxodev.dk/assets/8a41795c-dcbb-4ba1-a6ae-e2582bf01d41/image00011.jpeg"]
  },
  {
    "id": "c69ffadf-fe93-4788-8732-edc15b3cc229",
    "title": { "da": "DK Grøn Service på opgave" },
    "image": ["https://assets.auxodev.dk/assets/8a41795c-dcbb-4ba1-a6ae-e2582bf01d41/image00002.jpeg"]
  }
];
